import React from 'react';
import {Link} from 'react-router-dom';
import './Footer.css';
import company from '../config/company';
import curacareLogo from '../assets/images/headerLogo.webp';
import instagramLogo from '../assets/images/InstagramLogo.webp';

const pages = [
  {to: '/leistungen', label: 'Leistungen'},
  {to: '/pflegekosten', label: 'Pflegekosten'},
  {to: '/team', label: 'Team'},
  {to: '/faq', label: 'Häufige Fragen'},
  {to: '/galerie', label: 'Galerie'},
  {to: '/kontakt', label: 'Kontakt'}
];

const Footer = () => {
  const year = new Date().getFullYear();

  return (
    <footer className="footer">
      <div className="footer-inner">
        <div className="footer-brand">
          <img
            src={curacareLogo}
            alt="Cura Care Pflegedienst"
            className="footer-brand__logo"
            width="1182"
            height="358"
            loading="lazy"
          />
          <p className="footer-brand__text">
            Ambulante Pflege, Beratung und Weiterbildung in Eitorf und Umgebung. Persönlich,
            fachlich und verlässlich.
          </p>
          <a className="footer-social" href={company.instagram} target="_blank" rel="noreferrer">
            <img src={instagramLogo} alt="" width="22" height="22" loading="lazy" />
            Instagram
          </a>
        </div>

        <div className="f-col">
          <h3 className="f-title">Kontakt</h3>
          <ul className="f-list">
            <li><span>Telefon: </span><a href={`tel:${company.phoneIntl}`}>{company.phone}</a></li>
            <li><span>24h-Rufbereitschaft: </span><a href={`tel:${company.phoneIntl}`}>{company.phone}</a></li>
            <li><span>E-Mail: </span><a href={`mailto:${company.email}`}>{company.email}</a></li>
            <li><span>Bürozeiten: </span>{company.openingHours.label}</li>
          </ul>
        </div>

        <div className="f-col">
          <h3 className="f-title">Anschrift</h3>
          <address className="f-address">
            <div>{company.legalName}</div>
            <div>{company.street}</div>
            <div>{company.zip} {company.city}</div>
          </address>
          <a className="f-link" href={company.mapsUrl} target="_blank" rel="noreferrer">
            Route planen
          </a>
          <p className="f-note">Einzugsgebiet: Eitorf und Umgebung</p>
        </div>

        <div className="f-col">
          <h3 className="f-title">Seiten</h3>
          <ul className="f-list">
            {pages.map((page) => (
              <li key={page.to}><Link to={page.to}>{page.label}</Link></li>
            ))}
            <li><Link to="/" state={{scrollTo: 'partner'}}>Partner</Link></li>
          </ul>
        </div>
      </div>

      <div className="footer-bottom">
        <div className="footer-bottom__inner">
          <span>© {year} {company.legalName}</span>
          <nav aria-label="Rechtliches" className="footer-bottom__legal">
            <Link to="/impressum">Impressum</Link>
            <Link to="/datenschutz">Datenschutz</Link>
          </nav>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
